/**
 * Created by superman on 17/2/16.
 * http配置
 */

import axios from 'axios'
import store from '@/config/store'
import ElementUI from 'element-ui'
import utils from '@/config/cookieUtils'

// axios 配置
axios.defaults.baseURL = window.location.origin + '/api'
store.commit('changeUrl', axios.defaults.baseURL)
store.commit('changeLoginUrl', window.location.origin)
axios.defaults.headers.post['Content-Type'] = 'application/json'

// http request 拦截器
axios.interceptors.request.use(
  config => {
    let token = utils.get('Access-Token')
    if (token && token !== 'null') {
      config.headers['Access-Token'] = token
      config.headers['X-User-Account'] = utils.get('X-User-Account')
      config.headers['Current-Org-Id'] = utils.get('Current-Org-Id')
      config.headers['X-Client-Language'] = utils.get('X-Client-Language')
      config.headers['Role-Ids'] = utils.get('CURRENT_ROLE_ID_LIST')
      if (config.headers['Tenant-Id'] === null ||
        config.headers['Tenant-Id'] === '' ||
        config.headers['Tenant-Id'] === 'null' ||
        config.headers['Tenant-Id'] === undefined) {
        config.headers['Tenant-Id'] = utils.get('CURRENT_ROLE_ID')
      }
    }
    // 语言环境设置
    let currentLang = window.localStorage.getItem('tw_i18n_local')
    if (currentLang === 'en_US') {
      config.headers['X-Client-Language'] = 'en_US'
    } else {
      config.headers['X-Client-Language'] = 'zh_CN'
    }
    config.headers['X-Client-Id'] = '50f104a9932e412cba81a0224d78bc92'
    return config
  },
  err => {
    return Promise.reject(err)
  })

// http response 拦截器
axios.interceptors.response.use(
  response => {
    var serverResult = response.data.serverResult
    if (serverResult && serverResult.resultCode !== '200' && serverResult.resultCode !== '10007' && serverResult.resultCode !== '10008') {
      var msg = serverResult.internalMessage ? serverResult.internalMessage : serverResult.resultMessage
      if (serverResult.resultCode === 'PUC102PUC10211510000') {
        let currentLang = window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US'
        if (currentLang === 'en_US') {
          msg = 'Account is not bound role, please contact administrator.'
        } else {
          msg = '账号没有绑定角色，请联系管理员'
        }
      }
      ElementUI.Message(
        {
          type: 'error',
          message: msg
        })
      return Promise.reject(response)
    }
    return response
  },
  error => {
    if (error.response && error.response.data) {
      var errorJson = error.response.data
      if (errorJson.resultCode && errorJson.resultCode === 4210) {
        ElementUI.Message(
          {
            type: 'error',
            message: '账号已在其它地方登录',
            onClose: function () {
              store.commit('logout')
              utils.set('Access-Token', null)
              utils.set('Current_User_Id', '')
              utils.set('Current-Org-Id', '')
              utils.set('CURRENT_LOGIN_NAME', '')
              utils.set('CURRENT_TENANT_ID', '')
              utils.set('CURRENT_ORG_NAME', '')
              utils.set('CURRENT_ROLE_ID_LIST', [])
              utils.delete('TW_STA_CITY_ID')
              utils.delete('TW_STA_IP')
              utils.delete('TW_STA_SESSION_ID')
              utils.delete('TW_STA_SCHOOL_NUM')
              utils.delete('TW_STA_TEACHER_NUM')
              utils.delete('TW_STA_STUDENT_NUM')
              utils.delete('AUTO_LOGIN')
              utils.delete('LOGIN_NAME')
              utils.delete('LOGIN_PASSWORD')
              location.reload()
            }
          })
        return
      }
    }
    return Promise.reject(error.response.data)
  })

export default axios



// WEBPACK FOOTER //
// ./src/config/http.js